module.exports = "../../static/img/RazniiVozrast.3a33d15.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_us_main/RazniiVozrast.jpeg
// module id = fipI
// module chunks = 1